"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var PhoneEnd = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_PhoneEnd_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 16,
    height: 8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.05 8.958V8.16a.71.71 0 0 1 .206-.502.644.644 0 0 1 .248-.155 7.676 7.676 0 0 1 5.001 0 .69.69 0 0 1 .453.657v.797c0 .554.22 1.085.612 1.477l.866.865a1.392 1.392 0 0 0 1.969 0l.984-.985c.41-.409.611-.945.611-1.477 0-.532-.202-1.068-.61-1.477a10.439 10.439 0 0 0-14.77 0l-.046.045c-.793.803-.752 2.111.045 2.909l.985.985a1.393 1.393 0 0 0 1.97 0l.865-.865c.392-.392.611-.923.611-1.477ZM1.284 8.11c-.382.389-.389 1.066.042 1.497l.986.985a.393.393 0 0 0 .554 0l.865-.865c.205-.205.32-.48.319-.77V8.16c0-.453.18-.89.498-1.209.172-.171.386-.31.632-.394 1.83-.63 3.82-.63 5.65 0a1.69 1.69 0 0 1 1.128 1.603v.797c0 .288.115.565.32.77l.865.865a.393.393 0 0 0 .555 0l.984-.985c.212-.212.318-.49.318-.77s-.106-.558-.317-.77a9.439 9.439 0 0 0-13.357 0l-.042.043Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_PhoneEnd_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = PhoneEnd;
exports["default"] = _default;